<template>
	<div
		class="product-info"
		@click="productClick"
	>
		<div class="wrapper">
			<img class="product-icon" v-lazy="item.goods_img_480"/>
			<span class="product-title">{{ item.goods_name }}</span>
			<div class="product-bottom">
				<span class="product-price">￥<i class="price">{{ item.goods_promotion_price }}</i></span>				
				<!--<span class="product-buy" v-if="item.goods_score"><i>+</i>{{parseFloat(item.goods_score * item.goods_promotion_price / 10).toFixed(2)}}</span>-->
				<span class="product-buy" style="color:#999">售出 {{item.goods_salenum}} 件</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
  name: 'IndexProductBody',
  data () {
    return {
      itemWidth: 0,
      itemHeight: 0,
      showRightBorder: this.index % 2 == 0
    }
  },
  props: ['item', 'index'],
  computed: {

  },
  methods: {
    productClick: function () {
      this.$router.push({ name: 'HomeGoodsdetail', query: { goods_id: this.item.goods_id } })
    }
  }
}
</script>

<style lang="scss" scoped>
.border {
	border-right: 1px solid #f5f5f5;
}
.product-info {
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	width:50%;box-sizing:border-box;
	.wrapper{
		box-shadow: 0px 2px 4px #ececec;
		margin-left:$pageSpace;
		margin-bottom:.5rem;
		border-radius:.4rem;
	}
	.product-icon {
		align-self: center;
		width:100%;box-sizing:border-box;
		border-radius:.4rem;
	}
	.product-title {
		color: $formInputColor;
		font-size: $subFontSize;
		line-height:.8rem;
		height:1.6rem;
		margin-top: 0.4rem;
		overflow: hidden;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		padding:0 .3rem;
	}
	.product-bottom {
		display: flex;
		justify-content: space-between;
		margin-top:.4rem;
		line-height:1rem;
		padding:0 .3rem;
		padding-bottom:.5rem;
		.product-price {
			color: $primaryColor;
			font-size:$fontSize;
      .price{font-size:$mainFontSize}
		}
		.product-buy {
			color: $primaryColor;
			font-size:$fontSize;
			i { display: inline-block; vertical-align: middle; width: 0.6rem; height: 0.6rem; font-size:$fontSize; line-height: 0.6rem; font-style: normal; text-align: center; border-radius: 0.1rem; margin-right: 0.1rem; color: #FFF; background-color: $primaryColor}			
		}
	}
}
</style>
